import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@ui-kit/Text/Text";
import { setCurrentStep } from "@store/tripBuilder/tripBuilderReducer";
import { useAppDispatch } from "@store/store";

interface TripBuilderLoadingProps {
  isSuccess: boolean;
}

const TripBuilderLoading: FunctionComponent<TripBuilderLoadingProps> = ({
  isSuccess,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isSuccess) {
      dispatch(setCurrentStep("results"));
    }
  }, [isSuccess, dispatch]);

  return (
    <div className="trip-builder-container">
      <div className="trip-builder-loading">
        <img
          className="trip-builder-loading-image"
          src="/images/tour.gif"
          alt={t("screens.tripBuilder.loading.imageAlt")}
        />
        <Text variant="fontHeadingSmall">
          {t("screens.tripBuilder.loading.description")}
        </Text>
      </div>
    </div>
  );
};

export { TripBuilderLoading };
